<template>
  <v-container grid-list-md>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">contact_phone</v-icon> {{ $t('puntos_atencion.titulo') }}</h3>
    <v-layout row wrap>
      <v-flex xs12 sm4 md3 v-for="(cubiculo, index) in cubiculos" v-bind:key="index">
        <v-card flat outlined elevation="1" height="100%">
          <v-card-title class="default primary--text">
            <strong>{{cubiculo.identificador}}</strong>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn flat color="success" @click="ingresar(cubiculo)"><v-icon>check</v-icon> Ingresar</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat v-if="$store.state.cubiculo.identificador == cubiculo.identificador" color="red" @click="salir()"><v-icon>close</v-icon> Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';

export default {
  mixins: [validate, token],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
    this.recuperarPuntosAtencion();
    this.tiene_cubiculo = this.$store.state.cubiculo.id || 0;
  },
  mounted () {},
  data () {
    return {
      cubiculo_actual: {},
      tiene_cubiculo: 0,
      cubiculos: []
    };
  },
  methods: {
    recuperarPuntosAtencion () {
      this.cubiculos = [];
      this.$service.get(`system/operadores/cubiculos`, {})
      .then(response => {
        if (response) {
          response.forEach((item) => {
            this.cubiculos.push(item);
          });
        }
      });
    },
    ingresar (cubiculo) {
      if (this.$store.state.cubiculo.id !== cubiculo.id && this.$store.state.cubiculo.id > 0) {
        this.$confirm(`¿Está seguro de dejar el Punto de Atención e Iniciar en otro Punto de Atención?`, () => {
          this.cubiculo_actual = cubiculo;
          this.tiene_cubiculo = cubiculo.id;
          this.$storage.set('cubiculo', cubiculo.id);
          this.$storage.set('cubiculo_actual', cubiculo);
          this.$store.commit('cubiculo', this.cubiculo_actual);
          this.recordLogin();
          this.$router.push(`/chat/${cubiculo.id}`);
        });
      } else {
        if (this.tiene_cubiculo !== cubiculo.id) {
          this.tiene_cubiculo = cubiculo.id;
          this.cubiculo_actual = cubiculo;
          this.$storage.set('cubiculo', cubiculo.id);
          this.$storage.set('cubiculo_actual', cubiculo);
          this.$store.commit('cubiculo', this.cubiculo_actual);
          this.recordLogin();
        }
        this.$router.push(`/chat/${cubiculo.id}`);
      }
    },
    salir () {
      this.$confirm(`¿Está seguro de dejar el Punto de Atención?`, () => {
        this.recordLogOut();
        this.$storage.set('cubiculo', 0);
        this.$store.commit('cubiculo', {id: 0});
        this.tiene_cubiculo = 0;
      });
    },
    recordLogin () {
      if (this.user && this.cubiculo_actual && this.cubiculo_actual.id) {
        this.$service.put(`system/historial_punto_atencion/ingreso`, { id_punto_atencion: this.cubiculo_actual.id })
        .then(response => {
          if (response) {
            // this.$message.success(`Caso guardado exitosamente!`, null, { timeout: 2000 });
          }
        });
      }
    },
    recordLogOut () {
      if (this.user) {
        this.$service.put(`system/historial_punto_atencion/salida`, {})
        .then(response => {
          if (response) {
            // this.$message.success(`Caso guardado exitosamente!`, null, { timeout: 2000 });
          }
        });
      }
    }
  },
  components: {}
};
</script>
<style src="./cubiculo.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/operadores/PuntoAtencion.vue